/** Admin subscription-plan detail (edit + subscriber refunds) for one owner. */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../../src/context/OwnerScopeContext';
import PlanDetailScreen from '../../../../../owner/subscriptions/[id]';

export default function AdminOwnerPlanDetailScreen() {
  const { id, planId } = useLocalSearchParams<{ id: string; planId: string }>();
  return (
    <OwnerScopeProvider ownerId={id}>
      <PlanDetailScreen entityId={planId} />
    </OwnerScopeProvider>
  );
}
